import { defineStore } from 'pinia'
import { ref } from 'vue';
import { fetchData } from '@api/query';

export const useIssuesStore = defineStore('issues', () => {
  const lastIssues = ref([]);
  const allIssues = ref([]);
  const pagination = ref({ current_page: 1, last_page: 1, per_page: 12, total: 0 });
  const filterIssues = ref({years: []});

  const fetchIssues = async (filter:object = {}) => {
    try {
      const allIssuesResponse:any = await fetchData('issues', 'post', filter);
      const payload = allIssuesResponse?.data;
      allIssues.value = payload?.data ?? [];
      pagination.value = {
        current_page: payload?.current_page ?? 1,
        last_page: payload?.last_page ?? 1,
        per_page: payload?.per_page ?? 12,
        total: payload?.total ?? 0
      };
    } catch (error) {
      console.error('Error fetching issues:', error);
    }
  };

  const fetchLastIssues = async () => {
    try {
      const response:any = await fetchData('issues/latest', 'get');
      lastIssues.value = response?.data; 
    } catch (error) {
      console.error('Error fetching last Issues:', error);
    }
  };

  const fetchFilterIssues = async () => {
    try {
      const response:any = await fetchData('filters', 'get');
      filterIssues.value = response?.data;
    }catch (error) {
      console.error('Error fetching filter Issues:', error);
    }
  };

  return { allIssues, pagination, lastIssues, filterIssues, fetchIssues, fetchLastIssues, fetchFilterIssues };
});
